import './index.css'

function LinkedinFeature() {
  return (
    <section className="linkedin-feature">
      <div className="linkedin-feature-header">
        <div className="linkedin-feature-badge">
          <span>New Feature</span>
        </div>
        <h2 className="linkedin-feature-title">
          Connect LinkedIn. Schedule. Auto-publish.
        </h2>
        <p className="linkedin-feature-subtitle">
          Link your LinkedIn account and let Mako post on your behalf — on your schedule, in your voice. Nothing goes live without your say-so.
        </p>
      </div>

      <div className="linkedin-feature-steps">
        <div className="linkedin-feature-step">
          <div className="linkedin-feature-step-number">1</div>
          <h3 className="linkedin-feature-step-title">Connect your account</h3>
          <p className="linkedin-feature-step-text">
            Invite a LinkedIn profile to link with any voice. They authorise once and Mako handles the rest. Revoke access any time.
          </p>
        </div>

        <div className="linkedin-feature-step">
          <div className="linkedin-feature-step-number">2</div>
          <h3 className="linkedin-feature-step-title">Pick a time that works</h3>
          <p className="linkedin-feature-step-text">
            Choose a date and half-hour slot from the calendar. See every voice's posts in one view so nothing overlaps.
          </p>
        </div>

        <div className="linkedin-feature-step">
          <div className="linkedin-feature-step-number">3</div>
          <h3 className="linkedin-feature-step-title">Mako publishes for you</h3>
          <p className="linkedin-feature-step-text">
            When the time comes, Mako posts directly to LinkedIn. You stay visible and consistent without lifting a finger.
          </p>
        </div>
      </div>
    </section>
  )
}

export default LinkedinFeature
